import React, {Component} from 'react'
import {Select} from "antd";
import {escapeTurkishChars, izBlank, izEmpty} from "../constants";
import {ReadOutlined} from "@ant-design/icons";

export default class Blogs extends Component {

    constructor(props) {
        super(props);
    }

    getBlogUrl(blogId) {
        if (!blogId) return ""
        return this.props.blogs.filter(blog => blog.id === blogId)[0].url;
    }

    handleChange(blogId) {

        if (!blogId) return;

        this.props.onChange({target: {name: this.props.name, value: blogId, blogUrl: this.getBlogUrl(blogId)}});
    }

    render() {

        const {Option} = Select
        const {blogs, selectedBlogId, currentBlogId} = this.props;

        if (izEmpty(blogs)) return ""

        const placeholder = this.props.placeholder;

        return (
            <div className="custom-ant-selection">
                <Select
                    showSearch
                    allowClear
                    value={selectedBlogId}
                    suffixIcon={<ReadOutlined/>}
                    placeholder={placeholder}
                    optionFilterProp="children"
                    onChange={value => this.handleChange(value)}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(escapeTurkishChars(input).toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                        optionA.props.children.toLowerCase().localeCompare(optionB.props.children.toLowerCase())
                    }
                >
                    {
                        blogs.filter(blog => blog.id !== currentBlogId).map((item, index) => (
                            <Option key={item.id} value={item.id}>{item.lang + " - " + item.url + " - " + item.subject}</Option>
                        ))
                    }
                </Select>
            </div>
        )
    }

}